import { ThunkMiddleware } from "redux-thunk";
import { Middleware } from "redux";

const middleware = (): Array<ThunkMiddleware | Middleware> => {
  const middleware = <any[]>[];
  return middleware;
};

export default middleware;
